import { useNavigate} from 'react-router';
import "../css/content2.css"

export default function Content2() {
 const navigate = useNavigate();
 return (
  <div className="content2 pt-1 pt-md-5 pb-1 pb-md-5">
   <div className="container category mb-3 mt-3 p-5 pt-4">
    <p className="title">Kategori</p>
    <div className="row ms-1 me-1 ms-lg-5 me-lg-5 justify-content-center mb-5 mt-4">
     <div className="col col-3 border items" onClick={() => {
      navigate('/search?product=tas&page=1')
     }}>
      <img src={"/img/Tas.png"} className=" ms-auto me-auto d-block" width={100} alt="" />
      <p className="text-category text-center">Tas</p>
     </div>
     <div className="col col-3 border  items" onClick={() => {
      navigate('/search?product=sepatu&page=1')
     }}>
      <img src={"/img/Sepatu.png"} className=" ms-auto me-auto d-block" width={100} alt="" />
      <p className="text-category text-center">Sepatu</p>
     </div>
     <div className="col col-3 border  items" onClick={() => {
      navigate('/search?product=jas&page=1')
     }}>
      <img src={"/img/Jas.png"} className=" ms-auto me-auto d-block" width={100} alt="" />
      <p className="text-category text-center">Jas</p>
     </div>
     <div className="col col-3 border items" onClick={() => {
      navigate('/search?product=hoodie&page=1')
     }}>
      <img src={"/img/Hoodie.png"} className=" ms-auto me-auto d-block" width={100} alt="" />
      <p className="text-category text-center">Hoodie</p>
     </div>
     <div className="col col-3 border items" onClick={() => {
      navigate('/search?product=t-shirt&page=1')
     }}>
      <img src={"/img/T-shirt.png"} className=" ms-auto me-auto d-block" width={100} alt="" />
      <p className="text-category text-center">T-Shirt</p>
     </div>
     <div className="col col-3 border items" onClick={() => {
      navigate('/search?product=topi&page=1')
     }}>
      <img src={"/img/Topi.png"} className=" ms-auto me-auto d-block" width={100} alt="" />
      <p className="text-category text-center">Topi</p>
     </div>
     <div className="col col-3 border items" onClick={() => {
      navigate('/search?product=Ikat Pinggang&page=1')
     }}>
      <img src={"/img/Gesper.png"} className=" ms-auto me-auto d-block" width={100} alt="" />
      <p className="text-category text-center">Ikat Pinggang</p>
     </div>
     <div className="col col-3 border items" onClick={() => {
      navigate('/search?product=jam&page=1')
     }}>
      <img src={"/img/Jam.png"} className=" ms-auto me-auto d-block" width={100} alt="" />
      <p className="text-category text-center">Jam Tangan</p>
     </div>
     <div className="col col-3 border items" onClick={() => {
      navigate('/search?product=kacamata&page=1')
     }}>
      <img src={"/img/Kacamata.png"} className=" ms-auto me-auto d-block" width={100} alt="" />
      <p className="text-category text-center">Kacamata</p>
     </div>
     <div className="col col-3 border items" onClick={() => {
      navigate('/search?product=sandal&page=1')
     }}>
      <img src={"/img/Sandal.png"} className=" ms-auto me-auto d-block" width={100} alt="" />
      <p className="text-category text-center">Sandal</p>
     </div>
    </div>

   </div>
  </div>

 )
}